export default __webpack_public_path__ + "static/media/ElasticCache.9c35869a.svg";